import React from 'react';import { Form } from 'react-bootstrap';

const Select = props => {
  return (
    <Form.Group className={'mb-3 d-flex'}>
      <Form.Label className="col m-auto">{props.item.title}</Form.Label>
      <div className="col">
        <Form.Select onChange={props.onChange.bind(this, props.item.name)}>
          {props.item.variants.map((variant, i) => {
            return (
              <option key={i} value={variant}>
                {variant}
              </option>
            );
          })}
        </Form.Select>
      </div>
    </Form.Group>
  );
};

export default Select;
